<template lang='pug'>
  .fpui-dropdown-option(@click='close')
    slot
</template>

<script>

export default {
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
    close () {
      if (typeof this.$parent.close === 'function') {
        this.$parent.close()
      }
    }
  }
}
</script>

<style lang='less'>
.fpui-dropdown-option {
  color: #000;
  &:hover {
    background: #eee;
  }
}
</style>
